import { Box, Grid } from "@mui/material";
import EmployeesTable from "../../components/HR/EmployeesTable/EmployeesTable";
import EmployeePopup from "../../components/HR/EmployeePopup/EmployeePopup";

const EmployeesPage = () => {
  return (
    <Box className="incidents-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "600px" }}
            >
              <Grid item>
                <EmployeePopup />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <EmployeesTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmployeesPage;
